import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

/**
 * This class represents the header component.
 */
@Component({
    moduleId: module.id,
    selector: 'hbs-pageNotFound',
    templateUrl: 'pageNotFound.component.html'
})
export class PageNotFoundComponent implements OnInit {

    public link = '/';

    constructor(private router: Router) {
    }

    ngOnInit(): void {
        // TODO: calc link based in app: author/taker/admin/app
        //this.link = this.router.url;
    }


}
